module.exports = __webpack_public_path__ + "static/media/datasheet_musicData_row0_certificate.d705c689.png";